import { previousSaturday, format } from 'date-fns';
import { UF_FILTER_DISPLAY_LABELS, UF_FILTER_VALUE_ALIASES } from './data';
import { DetailsData, SelectData } from './types';

export const normalizeUfFilterValue = (value: string): string => {
  const alias = UF_FILTER_VALUE_ALIASES[value.trim().toLowerCase()];
  return alias ?? value;
};

export const normalizeUfFilterValues = (values: string[]): string[] => values.map(normalizeUfFilterValue);

export const denormalizeUfFilterValue = (value: string): string => {
  return UF_FILTER_DISPLAY_LABELS[value] ?? value;
};

export const denormalizeUfFilterValues = (values: string[]): string[] => values.map(denormalizeUfFilterValue);

export const toUfFilterSelectItems = (values: string[]): SelectData[] =>
  denormalizeUfFilterValues(values).map(value => ({ label: value, value }));

export const formatDate = (dateStr: string) => {
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
};

export const getLastSaturday = () => {
  const lastSaturday = previousSaturday(new Date());
  return format(lastSaturday, 'dd/MM/yy');
};

export const precoStatusMax = (data: DetailsData) => {
  const { precoMaximoResultado, precoMaximoCadastrado, precoMinimoCadastrado } = data;
  const isMaxWithinRange = precoMaximoResultado < precoMaximoCadastrado && precoMaximoResultado > precoMinimoCadastrado;

  return isMaxWithinRange;
};

export const precoStatusMin = (data: DetailsData) => {
  const { precoMaximoCadastrado, precoMinimoResultado, precoMinimoCadastrado } = data;
  const isMinWithinRange = precoMinimoResultado > precoMinimoCadastrado && precoMinimoResultado < precoMaximoCadastrado;

  return isMinWithinRange;
};
